<template>
  <!-- TODO: 增加搜索、过滤 -->
  <!-- TODO: 登录时长，在线时长，强制下线 -->
  <div id="bd-main">
    <el-row style="margin-top: 5px; margin-bottom: 5px;">
      <el-col :span="1"
        ><el-button size="mini" @click="refreshData()"
          ><i class="el-icon-refresh"></i>刷新</el-button
        ></el-col
      >
    </el-row>
    <el-table
      v-loading="isLoading"
      :data="statistics"
      border
      style="width: 100%"
      highlight-current-row
    >
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="realName" label="客服"></el-table-column>
      <el-table-column prop="acceptStatus" label="接待状态"></el-table-column>
      <el-table-column
        prop="connectionStatus"
        label="连接状态"
      ></el-table-column>
      <el-table-column prop="threadCount" label="接待人数"></el-table-column>
      <el-table-column prop="lt30sRate" label="30秒应答率"></el-table-column>
      <el-table-column
        prop="responseLt3mRate"
        label="3分钟人工回复率"
      ></el-table-column>
      <el-table-column prop="satisfyRate" label="评价满意度"></el-table-column>
      <el-table-column
        prop="averageResponseLength"
        label="平均人工响应时长"
      ></el-table-column>
      <el-table-column
        prop="agentMessageCount"
        label="发送消息条数"
      ></el-table-column>
      <el-table-column
        prop="agentMessageCount"
        label="发送消息字数"
      ></el-table-column>
      <el-table-column
        prop="visitorMessageCount"
        label="接收消息条数"
      ></el-table-column>
      <el-table-column
        prop="visitorWordCount"
        label="接收消息字数"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "bd-main",
  data() {
    return {
      resize: true,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "isAdmin",
      "userContacts",
      "showAuthority",
      "statisticsAgentToday",
      "statisticsAgentTodayUids",
    ]),
    //
    statistics() {
      let statistics = [];
      for (var i = 0; i < this.userContacts.length; i++) {
        let user = this.userContacts[i];
        // console.log("user:", user);
        for (var j = 0; j < this.statisticsAgentTodayUids.length; j++) {
          let statis = this.statisticsAgentTodayUids[j];
          if (user.uid === statis.uid) {
            statistics.push({
              realName: user.realName,
              uid: user.uid,
              acceptStatus: user.acceptStatus,
              connectionStatus: user.connectionStatus,
              threadCount: statis.threadCount, // 接待人次
              lt30sRate: statis.lt30sRate, // 30秒应答率
              responseLt3mRate: statis.responseLt3mRate, // 3分钟人工回复率
              satisfyRate: statis.satisfyRate, // 评价满意率
              averageResponseLength: statis.averageResponseLength, // 平均人工响应时长
              agentMessageCount: statis.agentMessageCount, // 发送消息数
              agentWordCount: statis.agentWordCount, // 发送消息字数
              visitorMessageCount: statis.visitorMessageCount, // 接收消息数
              visitorWordCount: statis.visitorWordCount, // 接收消息字数
            });
          }
        }
      }
      statistics.push({
        realName: this.userInfo.realName,
        uid: this.userInfo.uid,
        acceptStatus: this.userInfo.acceptStatus,
        connectionStatus: this.userInfo.connectionStatus,
        threadCount: this.statisticsAgentToday.threadCount, // 接待人次
        lt30sRate: this.statisticsAgentToday.lt30sRate, // 30秒应答率
        responseLt3mRate: this.statisticsAgentToday.responseLt3mRate, // 3分钟人工回复率
        satisfyRate: this.statisticsAgentToday.satisfyRate, // 评价满意率
        averageResponseLength: this.statisticsAgentToday.averageResponseLength, // 平均人工响应时长
        agentMessageCount: this.statisticsAgentToday.agentMessageCount, // 发送消息数
        agentWordCount: this.statisticsAgentToday.agentWordCount, // 发送消息字数
        visitorMessageCount: this.statisticsAgentToday.visitorMessageCount, // 接收消息数
        visitorWordCount: this.statisticsAgentToday.visitorWordCount, // 接收消息字数
      });
      return statistics;
    },
  },
  methods: {
    ...mapActions([
      "getContacts",
      "getAgentTodayStatistics",
      "getTodayStatisticsByAgentUid",
    ]),
    handleSuccess(contacts) {
      this.isLoading = false;
      for (var i = 0; i < contacts.length; i++) {
        let user = contacts[i];
        //
        let payload = { uid: user.uid };
        this.getTodayStatisticsByAgentUid(payload);
      }
    },
    handleFailed(error) {
      this.isLoading = false;
    },
    refreshData() {
      console.log("refreshData");
      this.getAgentTodayStatistics();
      // 限定为管理员加载其他用户统计信息
      if (this.isAdmin) {
        //
        if (this.userContacts.length > 0) {
          for (var i = 0; i < this.userContacts.length; i++) {
            let user = this.userContacts[i];
            //
            let payload = { uid: user.uid };
            this.getTodayStatisticsByAgentUid(payload);
          }
          return;
        }
        //
        this.isLoading = true;
        let payload = {
          successcb: this.handleSuccess,
          failedcb: this.handleError,
        };
        this.getContacts(payload);
      }
    },
  },
  created() {
    this.refreshData();
  },
};
</script>

<style scoped></style>